function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M70.685 12.846v10.826H34.244V1h23.532v6.024h7.088l5.821 5.822z",
  stroke: "#073331",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.147 23.893a3.208 3.208 0 11-6.415 0 3.208 3.208 0 016.415 0zM45.25 23.893a3.208 3.208 0 11-6.416 0 3.208 3.208 0 016.415 0z",
  fill: "#fff",
  stroke: "#073331",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.913 5.988v12.454h-24.13",
  stroke: "#073331",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.227 10.12H25.13",
  stroke: "#FFD747",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.79 14.79h9.34",
  stroke: "#A4E7DB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 19.46h24.13",
  stroke: "#F5BCBC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCar;